import { updateObject } from '../utility';
import { CLEAR_SESSION_VALUES, SET_SESSION_VALUES, UPDATE_SESSION_VALUES } from '../actions/types';

const initialState = {
    sessionValue: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_SESSION_VALUES:
            return updateObject(state, { sessionValue: action.payload });
        case UPDATE_SESSION_VALUES:
            return updateObject(state, {
                sessionValue: { ...state.sessionValue, ...action.payload }
            });
        case CLEAR_SESSION_VALUES:
            return updateObject(state, { sessionValue: action.payload });
        default:
            return state;
    }
};
